import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CartUIContextType {
  isCartOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
}

const defaultContext: CartUIContextType = {
  isCartOpen: false,
  openCart: () => console.warn('CartUIProvider missing: openCart no-op'),
  closeCart: () => console.warn('CartUIProvider missing: closeCart no-op'),
  toggleCart: () => console.warn('CartUIProvider missing: toggleCart no-op'),
};

const CartUIContext = createContext<CartUIContextType>(defaultContext);

export const CartUIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const toggleCart = () => setIsCartOpen(prev => !prev);

  return (
    <CartUIContext.Provider value={{ isCartOpen, openCart, closeCart, toggleCart }}>
      {children}
    </CartUIContext.Provider>
  );
};

export const useCartUI = () => {
  const context = useContext(CartUIContext);
  if (!context) {
    console.warn('useCartUI used outside provider, returning safe default.');
    return defaultContext;
  }
  return context;
};
